export default "__VITE_ASSET__Du68KNJ9__"